import { useState } from "react";
import { ChevronDown, Settings } from "lucide-react";
import clsx from "clsx";

const AEData = ({
  fuelId,
  fuelConsumption,
  sulfurContent,
  fuel_type
}) => {

  console.log("fuelId",fuelId)
  console.log("fuelConsumption",fuelConsumption)
  console.log("sulfurContent",sulfurContent)
  console.log("fuel_type",fuel_type)
  const [isOpen, setIsOpen] = useState(true);

  const normalizeFuelType = (fuelType) => {
    try {
      if (!fuelType) return "N/A";
      
      if (Array.isArray(fuelType)) {
        const flattenArray = (arr) => {
          return arr.reduce((flat, item) => {
            if (Array.isArray(item)) {
              return flat.concat(flattenArray(item));
            }
            return flat.concat(item);
          }, []);
        };

        const flattenedFuels = flattenArray(fuelType);
        
        const validFuels = flattenedFuels
          .map(fuel => {
            if (fuel == null) return '';
            return String(fuel).trim();
          })
          .filter(fuel => fuel && fuel !== "N/A" && fuel !== "null" && fuel !== "undefined");
        
        const uniqueFuels = [...new Set(validFuels)];
        return uniqueFuels.length > 0 ? uniqueFuels.join(", ") : "N/A";
      }
      
      if (typeof fuelType === 'string') {
        const trimmed = fuelType.trim();
        return trimmed && trimmed !== "N/A" ? trimmed : "N/A";
      }
      
      return String(fuelType || "N/A");
    } catch (error) {
      console.warn('Error normalizing fuel type:', error);
      return "N/A";
    }
  };

  const data = {
    "Fuel ID": fuelId,
    "Sulphur Content": `${sulfurContent.toFixed(1)}%`,
    "AE fuel Cons": `${fuelConsumption.toFixed(1)} MT/day`,
    "Fuel Type": normalizeFuelType(fuel_type)
  };

  const getColor = (key, value) => {
    if (key === "Fuel ID") return "text-blue-600";
    if (key === "Sulphur Content") {
      const num = parseFloat(value);
      if (num < 0.5) return "text-green-600 font-medium";
      if (num < 1.0) return "text-yellow-600 font-medium";
      return "text-red-600 font-semibold";
    }
    return "text-gray-700";
  };

  return (
    <div className="w-full h-full flex flex-col rounded-md overflow-hidden transition-all duration-300 min-h-0">
      {/* Header */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-gradient-to-br from-[#1a325d] to-[#12213f] w-full flex items-center justify-between px-4 py-3 text-left focus:outline-none group relative"
      >
        <div className="flex items-center gap-3">
          <div className="text-blue-400 hover:ring-blue-400 transition-all duration-300">
            <Settings size={20} strokeWidth={2} />
          </div>
          <h3 className="text-[15px] font-semibold text-white tracking-wide">
            AE Data
          </h3>
        </div>

        <ChevronDown
          className={clsx(
            "w-5 h-5 text-white transition-transform duration-300",
            isOpen && "rotate-180"
          )}
        />
      </button>

      {/* Fixed Content Section */}
      <div
        className={clsx(
          "transition-all duration-500 overflow-hidden",
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        )}
      >
        <div className="px-4 py-4 bg-white shadow-xl backdrop-blur-md">
          <div className="flex flex-col">
            {Object.entries(data).map(([key, value]) => (
              <div
                key={key}
                className="flex items-center justify-between py-3 text-sm text-[#0a2540] border-b border-blue-400/20 last:border-none"
              >
                <span className="font-medium">{key}</span>
                <span className={clsx("font-semibold tracking-wide", getColor(key, value))}>
                  {value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AEData;